module.exports = __webpack_public_path__ + "img/Zoox_Pay_.d6ee4220.png";